/**
 * Test ID utilities for Badge component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for badges with text children
 * @param label - Badge text content (will be converted to kebab-case)
 * @returns Test ID string
 */
export const setBadgeTestId = (label: string): string =>
  generateTestId("Badge", label.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for badges without text children (icon-only or complex children)
 * @param variant - Badge variant (default, secondary, destructive, outline)
 * @returns Test ID string
 */
export const setBadgeVariantTestId = (variant: string = "default"): string =>
  generateTestId("Badge", `${variant}-badge`);
